import { Formik } from 'formik'
import { FormattedMessage, useIntl } from 'react-intl'
import { object, string } from 'yup'

import { Text } from '@/components/Form'
import Modal from '@/components/Modal'

import Buttons from './Fields/Buttons'
import messages from './messages'

import './index.scss'

import CopyTextButton from '@/components/CopyTextButton'
import KeyValue from '@/components/KeyValue'

const schema = (intl: any) => {
  return object().shape({
    name: string().label(intl.formatMessage(messages.toolbarNameRequired)).min(2).max(128).required(),
    description: string()
      .trim()
      .max(500)
      .test('toolbarDescRequired', intl.formatMessage(messages.toolbarDescRequired), value => {
        return !!value && value.length > 1
      })
      .required()
  })
}
const initialFormValues = {
  name: '',
  description: '',
  clientCredential: { clientId: '' }
}

const AddEditModal = ({ isEdit, formValues, onClose, onSubmit, open = false }: any) => {
  const intl = useIntl()

  const initialValues = { ...initialFormValues, ...formValues }

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={schema(intl)}
      onSubmit={onSubmit}
      render={({ values, handleSubmit, resetForm }) => {
        return (
          <Modal
            onClose={() => {
              resetForm({})
              onClose()
            }}
            isOpen={open}
          >
            <div className="column flex-center">
              <div className="column">
                <div className="modal-title">
                  {isEdit ? (
                    <FormattedMessage {...messages.editToolbar} />
                  ) : (
                    <FormattedMessage {...messages.newToolbar} />
                  )}
                </div>
                <div className="modal-required">
                  <FormattedMessage {...messages.modalRequired} />
                </div>

                <Text className="modal-label" label={<FormattedMessage {...messages.toolbarName} />} name="name" />
                <Text
                  className="modal-label"
                  label={<FormattedMessage {...messages.toolbarDesc} />}
                  name="description"
                />
                <div className="credential-label">
                  <FormattedMessage {...messages.credentials} />
                </div>
                <div className="sensitive-wrapper">
                  {values.clientCredential &&
                  (values.clientCredential.clientSecret || values.clientCredential.clientId) ? (
                    <>
                      {values.clientCredential.clientId && (
                        <KeyValue>
                          <KeyValue.Label>
                            <FormattedMessage {...messages.clientId} />
                          </KeyValue.Label>
                          <KeyValue.Value>{values.clientCredential.clientId}</KeyValue.Value>
                        </KeyValue>
                      )}
                      <KeyValue>
                        <KeyValue.Label>
                          <FormattedMessage {...messages.clientSecret} />
                          {values.clientCredential.clientSecret && (
                            <span className="warning">
                              <FormattedMessage {...messages.onlyDisplayedOnce} />
                            </span>
                          )}
                        </KeyValue.Label>
                        {values.clientCredential.clientSecret ? (
                          <>
                            <KeyValue.Value>{values.clientCredential.clientSecret} </KeyValue.Value>
                            <CopyTextButton text={values.clientCredential.clientSecret} />
                          </>
                        ) : (
                          <span className="already-gen">
                            <FormattedMessage {...messages.alreadyGenerated} />
                          </span>
                        )}
                      </KeyValue>
                    </>
                  ) : (
                    <Buttons onSubmit={handleSubmit} />
                  )}
                </div>
                {isEdit && <Buttons isEdit={isEdit} onClose={onClose} onSubmit={handleSubmit} />}
              </div>
            </div>
          </Modal>
        )
      }}
    />
  )
}

AddEditModal.defaultProps = {
  isOpen: true,
  isEdit: false,
  formValues: initialFormValues
}

export default AddEditModal
